import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { LiveCasinoGridItemBetIntervalCasino777Box } from "./live-casino-grid-item-bet-interval.casino777.box";
import {LiveCasinoGridItemBetIntervalDefaultBox} from "./live-casino-grid-item-bet-interval.default.box";
import {LiveCasinoGridItemBetIntervalSIBox} from "./live-casino-grid-item-bet-interval.si.box";

export const LiveCasinoGridItemBetIntervalBox = styledByTheme(LiveCasinoGridItemBetIntervalDefaultBox)
    .forCasino777(LiveCasinoGridItemBetIntervalCasino777Box)
    .forSI(LiveCasinoGridItemBetIntervalSIBox)
    .apply();
